import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { AuthInit } from './modules/auth'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import { Toaster } from 'react-hot-toast';

const App = () => {
    return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <DndProvider backend={HTML5Backend}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
              <Toaster toastOptions={{className: "fs-7"}}/>
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </DndProvider>
    </Suspense>
  )
}

export {App}

